import { Languages, BookA, Brain } from 'lucide-react';
import { CuerpoLayout } from '@/components/oposiciones/CuerpoLayout';
import badge from '@/assets/badge-guardia-civil.png';

export function GuardiaCivilLayout() {
  return (
    <CuerpoLayout
      basePath="/app/guardia-civil"
      shortLabel="Guardia Civil"
      badgeImage={badge}
      accent="green"
      areaId="guardia_civil"
      downloadsMode="oposiciones_guardia_civil"
      caseLabel="Examen Oficial"
      extraNavItems={[
        { id: 'ingles',       label: 'Inglés B1',     icon: Languages, path: '/app/guardia-civil/ingles' },
        { id: 'lengua',       label: 'Lengua',        icon: BookA,     path: '/app/guardia-civil/lengua' },
        { id: 'psicotecnico', label: 'Psicotécnico',  icon: Brain,     path: '/app/guardia-civil/psicotecnico' },
      ]}
    />
  );
}
